<template>
  <v-container
    id="widgets"
    fluid
    tag="section">
    <base-material-card class="px-5 py-3">
      <template v-slot:heading>
        <div class="headline mt-3 font-weight-light">
          Relatório de serviços agendado
        </div>
      </template>
      <v-form id="appTable">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          min-width="290px"
          offset-y>
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="datestring"
              color="secondary"
              prepend-icon="mdi-calendar-outline"
              readonly
              v-on="on"/>
          </template>
          <v-date-picker
            v-model="date"
            color="secondary"
            no-title
            scrollable
            type="month"
            @input="menu1 = false"/>
        </v-menu>
        <v-divider class="mb-3" />
        <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Serviço</th>
                  <th class="text-left">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.nome">
                  <td>{{ item.nome }}</td>
                  <td>{{ item.total }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>


      </v-form>
    </base-material-card>
  </v-container>
</template>
<script>

  function gettanggal (str) {
    if (str != null) {
      return str.substring(5, 7) + '/' + str.substring(0, 4)
    }
    return ''
  }
  function getDateJson (str) {
    if (str != null) {
      return str.substring(0, 4) + '-' + str.substring(5, 7) + '-01'
    }
    return ''
  }

  export default {
    name: 'Widgets',
    components: {

    },
    data: () => ({
      date: new Date().toISOString().substr(0, 7),
      menu1: false,
      dark: true,
      datestring: gettanggal(new Date().toISOString().substr(0, 7)),
      dateJson: getDateJson(new Date().toISOString().substr(0, 7)),
      items: [
/*        {
          total: 10,
          nome: 'w3g1',
        },
        {
          total: 9,
          nome: 'w3g2',
        },     */     
      ],
    }),
    watch: {
      date: function (val, oldVal) {
        this.datestring = gettanggal(val)
        this.dateJson = getDateJson(val)
        this.doConsultaAgenda()
      },
    },
    mounted () {
      this.doConsultaAgenda()
    },    
    methods: {     
      doConsultaAgenda () {
        if (localStorage.chaveFuncionarioMobile) {
          var funcionarioMobile = {
            'chave': localStorage.chaveFuncionarioMobile,
          }
          try {
            if (funcionarioMobile.chave) {
              this.$http.post('/ProjetoX/rest/externo/funcionario/mobile/totalservicoperiodo/' + this.dateJson, funcionarioMobile)
                .then(resposta => {
                  this.items = resposta.data
                })
            }
          } catch (error) {
            alert('Erro ao listar agenda.')
            console.log(error)
          }
        }
      },      
    },
  }
</script>
